/*
 * Copyright (c) 2022. Dave van Rijn Development
 */
import './style/home.scss';

import React, {useEffect} from 'react';
import {getImg, getImgSizes, getImgSources, pageScroller} from "../../util/utils";
import {useLocation, useNavigate} from 'react-router';
import {Helmet} from 'react-helmet';
import {slogan} from "../../util/texts";
import TextContainer from "../textContainer/textContainer";
import {Link, sendGaEvent, sendGaPageView} from '@dvrd/dvr-controls';
import {CITIES} from "../../util/constants";
import {afterNavigate} from "../../util/navigationUtil";
import IDate from '@dvrd/idate';

export default function Home() {
    const {pathname} = useLocation();
    const navigate = useNavigate();

    function onClickContact() {
        sendGaEvent('click', 'home', 'contactformulier');
        afterNavigate('/contact', false, 'contact', pageScroller, navigate);
    }

    useEffect(() => {
        sendGaPageView('/home');
    }, []);

    function renderWelcome() {
        return (
            <TextContainer title='Welkom' invert={false}>
                Leuk dat u een kijkje komt nemen op de website van Bowie's Hondenuitlaatservice.<br/>
                <label>Neem gerust contact op via het <Link
                    onClick={onClickContact}>contactformulier</Link>.</label><br/><br/>
                Bowie's Hondenuitlaatservice haalt honden op in:
                <div className='city-list'>
                    {CITIES.map((city: string, index: number) => (
                        <label key={index}>- {city}</label>
                    ))}
                </div>
            </TextContainer>
        );
    }

    function renderAbout() {
        return (
            <TextContainer title='Over mij' invert className='text-container-about'>
                <div className='about-container' id='leonique'>
                    <div className='imgs-container'>
                        <div className='img'>
                            <img src={getImg('home/leonique-strand-x960')} alt="Bowie's" className='about-img'
                                 srcSet={getImgSources('home/leonique-strand', [300, 480, 640, 960])}
                                 sizes={getImgSizes([300, 480, 640], 960)} loading='lazy'/>
                            <label className='img-label'>Leonique & Djuna</label>
                        </div>
                        <div className='img'>
                            <img src={getImg('home/djuna-bowie-x960')} alt="Bowie's" className='about-img left'
                                 srcSet={getImgSources('home/djuna-bowie', [300, 480, 640, 960])}
                                 sizes={getImgSizes([300, 480, 640], 960)} loading='lazy'/>
                            <label className='img-label'>Djuna & Bowie</label>
                        </div>
                    </div>
                    <div className='about-text-container'>
                        <h2 className='about-title'>Leonique</h2>
                        <p className='about-text'>
                            Ik ben Leonique van
                            Doorn, {new IDate('1999-09-24').absDiff(IDate.now(), 'years')} jaar en wonend in De Ronde
                            Venen.<br/><br/>
                            Al heel mijn leven heb ik dieren om mij heen: honden, katten, paarden, konijnen, cavia’s.
                            Dieren zijn voor mij onmisbaar.<br/><br/>
                            Toen ik 7 jaar was mocht ik mijn eerste eigen hondje ophalen. Dit was Bowie. Hij is helaas
                            op 16 september 2019 overleden. Naar hem heb ik mijn uitlaatservice vernoemd. Op 8 juli 2017
                            kreeg ik er een eigen puppy bij: Djuna. Djuna is een Keeshond x Tibetaanse Spaniël teefje
                            van {new IDate('2017-04-10').absDiff(IDate.now(), 'years')} jaar.
                            Zij zal regelmatig met de hondenuitlaatservice meegaan.<br/><br/>
                            Bij een andere hondenuitlaatservice heb ik met veel plezier ervaring opgedaan met
                            verschillende hondenrassen en karaktereigenschappen. Doordat ik dit werk zo geweldig vind,
                            heb ik de stap gezet om met Bowie's te starten.<br/><br/>
                            Iedere hond verdient een fantastisch uitje en ik zet me daar 100% voor in!
                        </p>
                    </div>
                </div>

                {/*<div className='about-container' id='iris'>*/}
                {/*    <div className='about-text-container'>*/}
                {/*        <h2 className='about-title'>Iris</h2>*/}
                {/*        <p className='about-text'>*/}
                {/*            Hi! Ik ben Iris Verweij, {new IDate('1999-01-03').absDiff(IDate.now(), 'years')} jaar en*/}
                {/*            wonend in De Ronde Venen.<br/><br/>*/}
                {/*            Wij hebben thuis zelf een labrador*/}
                {/*            van {new IDate('2020-10-01').absDiff(IDate.now(), 'years')} jaar en een ruwharige*/}
                {/*            dwergteckel van {new IDate('2022-12-28').absDiff(IDate.now(), 'years')} jaar. Een hele leuke*/}
                {/*            combinatie als je het mij vraagt.<br/><br/>*/}
                {/*            Ik ben gek op honden en ik heb in de afgelopen jaren zelf ook ervaring opgedaan in honden*/}
                {/*            uitlaten en oppassen. Ik deed dit via een online platform naast mijn school, stage en*/}
                {/*            bijbaan. Dit voelde nooit als werk en deed ik er echt bij omdat ik het leuk vond,*/}
                {/*            het extra zakcentje was mooi meegenomen.<br/><br/>*/}
                {/*            Toen ik mijn diploma bedrijfskunde haalde en ik 3 dagen per week op kantoor ging werken*/}
                {/*            plus een 1-jarige cursus ging volgen, stopte ik met de honden. Nu mijn cursus afgerond*/}
                {/*            is, heb ik besloten naast mijn kantoorbaan weer de honden in te gaan. Ik miste het te erg*/}
                {/*            en precies op dat moment kwam deze kans. Nou, ‘meant to be’ toch.<br/><br/>*/}
                {/*            Ik heb er zin in en kijk uit naar alle honden die ik blij kan maken met mijn bezoek.*/}
                {/*        </p>*/}
                {/*    </div>*/}
                {/*    <div className='imgs-container'>*/}
                {/*        <div className='img'>*/}
                {/*            <img src={getImg('home/iris-pip-lovi-x960')} alt="Bowie's" className='about-img right'*/}
                {/*                 srcSet={getImgSources('home/iris-pip-lovi', [300, 480, 640, 960])}*/}
                {/*                 sizes={getImgSizes([300, 480, 640], 960)} loading='lazy'/>*/}
                {/*            <label className='img-label'>Iris & Pip & Lovi</label>*/}
                {/*        </div>*/}
                {/*        <div className='img'>*/}
                {/*            <img src={getImg('home/iris-pip-x960')} alt="Bowie's" className='about-img'*/}
                {/*                 srcSet={getImgSources('home/iris-pip', [300, 480, 640, 960])}*/}
                {/*                 sizes={getImgSizes([300, 480, 640], 960)} loading='lazy'/>*/}
                {/*            <label className='img-label'>Iris & Pip</label>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </TextContainer>
        );
    }

    return (
        <div className='home' id='home'>
            <Helmet>
                <title>Bowie's {pathname.includes('over-mij') ? '| Over mij' : 'Hondenuitlaatservice'}</title>
                <link rel="canonical" href={`https://bowies.nl${pathname}`}/>
            </Helmet>
            <div className='slogan-container'>
                <label className='slogan'>{slogan}</label>
            </div>
            {renderWelcome()}
            {renderAbout()}
        </div>
    )
}